// extracted by mini-css-extract-plugin
export default {"tableContainer":"UserCallback_tableContainer__DxBIF","tableBodyContainer":"UserCallback_tableBodyContainer__BYlIF","btn":"UserCallback_btn__-G+GI"};